import React from 'react';
import PropTypes from 'prop-types';
import { Link as ScrollLink } from 'react-scroll';
import { Navbar, Nav, NavDropdown, MenuItem, Glyphicon } from 'react-bootstrap';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

import messages from './messages';
import logo from './logo.svg';
import LanguageSwitcher from '../LanguageSwitcher';

const scrollOptions = {
  spy: true,
  smooth: true,
  duration: 500,
  role: 'button',
};

// eslint-disable-next-line react/prop-types
const ScrollNavItem = ({ children }) =>
  <li role="presentation">
    {children}
  </li>;

class Navigation extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string.isRequired,
    }).isRequired,
  };

  render() {
    const { intl, location: { pathname } } = this.props;
    const isMainPage = pathname === '/';

    const topLink = isMainPage
      ? <ScrollLink {...scrollOptions} to="top">
          <img src={logo} alt={intl.formatMessage(messages.brandName)} />
        </ScrollLink>
      : <Link to="/">
          <img src={logo} alt={intl.formatMessage(messages.brandName)} />
        </Link>;
    return (
      <Navbar className="top-nav" collapseOnSelect fluid fixedTop>
        <Navbar.Header>
          <Navbar.Brand>
            {topLink}
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav pullRight>
            <ScrollNavItem>
              {isMainPage &&
                <ScrollLink {...scrollOptions} to="getSmart">
                  <FormattedMessage {...messages.products} />
                </ScrollLink>}
            </ScrollNavItem>
            <ScrollNavItem>
              {isMainPage &&
                <ScrollLink {...scrollOptions} to="services">
                  <FormattedMessage {...messages.services} />
                </ScrollLink>}
            </ScrollNavItem>

            <NavDropdown
              eventKey={3}
              title={<Glyphicon glyph="menu-hamburger" />}
              id="top-nav-dropdown"
            >
              <MenuItem
                eventKey={3.1}
                href="http://www.waltzingatoms.com/motivation"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage {...messages.aboutUs} />
              </MenuItem>
              <MenuItem
                eventKey={3.2}
                href="/time"
                target="_self"
                rel="noopener noreferrer"
              >
                Waltzing Time
              </MenuItem>
              <MenuItem
                eventKey={3.3}
                href="/license"
                target="_self"
                rel="noopener noreferrer"
              >
                Waltzing License
              </MenuItem>
              <MenuItem
                eventKey={3.4}
                href="https://www.danube.ai/"
                target="_blank"
                rel="noopener noreferrer"
              >
                danube.ai
              </MenuItem>
              <MenuItem
                eventKey={3.4}
                href="http://www.waltzingatoms.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Waltzing Atoms
              </MenuItem>
              <MenuItem
                eventKey={3.4}
                href="http://creativity.waltzing.at"
                target="_blank"
                rel="noopener noreferrer"
              >
                Waltzing Creativity
              </MenuItem>
              <MenuItem
                eventKey={3.5}
                href="http://www.waltzingatoms.com/career"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage {...messages.careers} />
              </MenuItem>
              <MenuItem eventKey={3.6} href="mailto:office@3datax.com">
                <FormattedMessage {...messages.contactUs} />
              </MenuItem>
              <MenuItem
                eventKey={3.7}
                href="http://www.waltzingatoms.com/3datax"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage {...messages.imprint} />
              </MenuItem>
              <MenuItem
                eventKey={3.8}
                href="https://forum.waltzingatoms.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage {...messages.forum} />
              </MenuItem>
              <LanguageSwitcher />
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default withRouter(injectIntl(Navigation));



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js